import type {
  GetGeoLocationRequest,
  SearchAddressRequest,
  GetAddressDetailsRequest,
  GetPostalCodeRequest,
} from './types';

export const DEVICE_QUERY_KEYS = {
  geoLocation: ({ ip }: GetGeoLocationRequest) => ['device', 'geo-location', ip] as const,
  searchStreetAddress: ({ input, countryCode }: SearchAddressRequest) =>
    ['device', 'search-address', input, countryCode] as const,
  getAddressDetails: ({ placeId }: GetAddressDetailsRequest) => ['device', 'address-details', placeId] as const,
  getPostalCode: ({ postalCode, countryCode }: GetPostalCodeRequest) =>
    ['device', 'get-postal-code', postalCode, countryCode] as const,
} as const;
